import { useEffect, useState, useRef } from 'react'
import PageApp from '../../../Page';
import ModalEdit from './Edit'
import { HomeOutlined, UnorderedListOutlined, ClockCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import { Table, Empty, Modal, Divider, Button, message, Space } from 'antd';
import { getAll, drop } from '../../../../apis/OdooTimeSheetApi';
import _ from 'lodash'

const { confirm } = Modal;

const routes = [{
  href: '',
  title: <>
    <HomeOutlined />
    <span>Inicio</span>
  </>,
},
{
  href: '',
  title: (
    <>
      <UnorderedListOutlined />
      <span>Configuración</span>
    </>
  ),
},
{
  href: '',
  title: (
    <>
      <UnorderedListOutlined />
      <span>Asistencia</span>
    </>
  ),
},
{
  href: '',
  title: (
    <>
      <UnorderedListOutlined />
      <span>Tiempos de Trabajo</span>
    </>
  ),
}];

const TimeLeave = () => {
  const [items, setItems] = useState([]);
  const [openEdit, setOpenEdit] = useState(false);
  const [objectSelected, setobjectSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const columns = [
    {
      title: 'Empleado',
      dataIndex: 'empleado.name',
      key: 'empleado.name',
      render: (item, object) => {
        return <Space>
          <span>{object.empleado.name}</span>
        </Space>
      }
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Analitica',
      dataIndex: 'analitica',
      key: 'analitica',
      render: (analitica) => analitica?.name || 'N/A'
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      render: (item, object) => {
        return <Space>
          <Button type='primary' size='small' onClick={() => {
            openDetails(object);
          }}>Editar</Button>
          <Button type='primary' size='small' danger onClick={() => {
            deleteConfirm(object);
          }}>Eliminar</Button>
        </Space>
      }
    }
  ];

  const openDetails = async (object) => {
    setOpenEdit(true);
    setobjectSelected(object);
  }

  const deleteConfirm = async (item) => {
    confirm({
      title: '¿Confirmas en eliminar el tiempo de ausencia?',
      icon: <ExclamationCircleFilled />,
      content: 'No podrás recuperar su información',
      onOk: () => { deleteOk(item.id) },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const deleteOk = async (id) => {
    const response = await drop(id);
    if (response.ok) {
      message.success('¡El tiempo de ausencia ha sido eliminado!');
    }
    await refreshData();
  }

  const btnClick = () => {
    setOpenEdit(true);
    setobjectSelected(null);
  }

  const onHandlerFinish = async (refresh) => {
    setOpenEdit(false);
    if (refresh) {
      await refreshData();
    }
  }

  const refreshData = async () => {
    const response = await getAll();
    if (response.ok) {
      let items = response.payload;
      setItems(items);
    }

    setLoading(false);
  }

  const effectRan = useRef(false);
  useEffect(() => {

    if (!effectRan.current) {
      (async () => {
        await refreshData();
      })();
    }

    return () => effectRan.current = true;
  }, []);

  return <PageApp
    routes={routes}
    title={'Tiempos de Trabajo'}
    cardTitle='Lista de tiempos de trabajo'
    extraCard={[
      <Button type="primary" onClick={btnClick}>
        Agregar Hoja de Hora
      </Button>
    ]}>
    {
      loading ? (
        <p>Loading...</p>
      ) : <>
        {
          items.length == 0 ? <Empty /> :
            <Table dataSource={items} columns={columns} />
        }
      </>
    }
    {
      (openEdit && objectSelected && objectSelected.id > 0) &&
      <ModalEdit title={"Editar Hoja de Trabajo"} id={objectSelected.id} open={openEdit} finish={onHandlerFinish} />
    }
    {
      (openEdit && !objectSelected) &&
      <ModalEdit title={"Crear Hoja de Trabajo"} open={openEdit} finish={onHandlerFinish} />
    }

  </PageApp>
}

export default TimeLeave;
